export enum PositionType {
  SHORT = 'SHORT',
  LONG = 'LONG',
  LONG_PUB = 'LONG_PUBLIC'
}

/**
 * Single-letter label for a position's L/S badge: 'L' for LONG, 'S' for SHORT, null for anything
 * else (including LONG_PUBLIC), which renders no badge.
 */
export function positionTypeBadgeLabel(positionType: PositionType | string): string | null {
  if (positionType === PositionType.LONG) {
    return 'L';
  }
  return positionType === PositionType.SHORT ? 'S' : null;
}
